import { useOutletContext } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import employees from 'modules/employees/store/collections/employees'
import AddSupervisorModalV1 from 'modules/surveys/components/Configuration/AddSupervisorModalV1'
import AddEditorModal from 'modules/surveys/components/Settings/Editors/AddEditorModal'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'
import type SurveyForm from 'modules/surveys/store/models/Form'

export default function AddSupervisorPage() {
  const { form } = useOutletContext<{ form: SurveyForm }>()
  const { survey, hasSurveyV2 } = useSurveyShowContext()

  const { loading: loadingEmployees } = useAsyncData(
    () => employees.fetch({ withCachedFetchParams: true }),
    []
  )

  if (loadingEmployees) {
    return <Loading />
  }

  return hasSurveyV2 && survey ? (
    <AddEditorModal survey={survey} employees={employees} />
  ) : (
    <AddSupervisorModalV1 form={form} employees={employees} />
  )
}
